{
  "sitemaps": {
    "title": "Mapas do site",
    "page_content": "Os sitemaps permitem que você integre desenhos CAD detalhados de locais/localizações no mapa. Você pode adicionar e gerenciar mapas do site e desenhos CAD abaixo.",
    "no_sitemaps_title": "Está um pouco vazio aqui...",
    "no_sitemaps_body_1": "Atualmente, não há localizações ou mapas do site importantes! Clique no ",
    "no_sitemaps_body_2": " botão para adicionar quantos locais quiser",
    "add_sitemap": "Adicionar mapa do site",
    "create_sitemap_comming_soon_message": "O upload automático de desenhos CAD estará disponível em breve. Enquanto isso, nossa equipe de suporte pode enviar seus CADs para você.",
    "click_to_open_sitemap_options": "Clique para abrir as opções do mapa do site",
    "edit_sitemap": "Editar mapa do site",
    "delete_sitemap": "Excluir mapa do site"
  },
  "user_settings": "Configurações do usuário",
  "help": "Socorro",
  "help_menu": {
    "title": "Ajuda e recursos",
    "getting_started": "Começando com a Iventis",
    "knowledge_base": "Base de conhecimento da Iventis",
    "support": "Suporte",
    "about": "Sobre a Iventis"
  },
  "sso": {
    "title": "Configuração de SSO",
    "page_content": "Aqui você pode editar a configuração de SSO para o projeto",
    "response_signing_certificate": "Certificado de assinatura de resposta",
    "meta_data_location": "URL de metadados do provedor de identidade",
    "identity_provider": "ID da entidade do provedor de identidade",
    "saved": "Configuração de SSO salva com sucesso",
    "setup_description": "Ao configurar o SSO com seu provedor de identidade, você precisará selecionar SAML e inserir as seguintes propriedades",
    "entity_id": "ID da entidade",
    "rely_url": "URL de resposta",
    "signon_url": "URL de login",
    "sso_enabled": "SSO habilitado",
    "enable_confirmation": "Tem certeza de que deseja habilitar o SSO para este projeto?",
    "enable_confirmation_warning": "Certifique-se de que o SSO esteja configurado corretamente antes de ativá-lo para evitar o bloqueio de usuários do projeto",
    "disable_confirmation": "Tem certeza de que deseja desativar o SSO para este projeto?",
    "disable_confirmation_warning": "A desativação do SSO exigirá que todos os usuários que atualmente dependem do SSO definam uma senha. Eles receberão um e-mail com instruções para criar sua senha para manter o acesso ao projeto.",
    "disable_confirmation_warning2": "Depois que o SSO for desativado, reativá-lo exigirá a reativação manual do acesso ao SSO para cada usuário."
  },
  "projectCustomisation": {
    "projectNameWarning": "Alterar o nome do projeto mudará o seguinte:",
    "projectNameWarningSsoKey": "Então:",
    "projectNameWarningSsoValue": "URLs de configuração (se habilitado)",
    "projectNameWarningUrlKey": "URL do projeto:"
  },
  "projectRolePermissions": {
    "projectAdministratorsSubMenu": "Administradores do projeto",
    "projectAdministratorsTitle": "Administradores do projeto",
    "projectAdminRoleDescription": "Aqui você pode adicionar ou remover administradores de projetos. Esses usuários têm acesso e podem editar todos os dados, configurações e permissões do projeto.",
    "addAdmin": "Adicionar usuário",
    "addProjectAdmin": "Adicionar administrador do projeto",
    "removeAdmin": "Remover status de administrador",
    "removeAdminConfirm": "Essa pessoa não será mais administradora do projeto. Você deseja continuar?",
    "removeYourselfAdminConfirm": "Você perderá o acesso de administrador do projeto e não poderá adicioná-lo novamente. Você deseja continuar?",
    "projectAdminsSelectedConfirmButton": "Adicionar selecionado",
    "addAdminsToast": "Administradores adicionados com sucesso",
    "removeAdminToast": "Administrador removido com sucesso"
  }
}